import { BOTTOM_BAR_HEIGHT } from 'modules/menu/constants';

export default {
  root: {
    height: `${BOTTOM_BAR_HEIGHT}px`,
    maxWidth: '500px',
  },
};
